// removed by extract-text-webpack-plugin
module.exports = {"flipInX":"_32wnm","ContainersSingle":"_4bJLT","ContainersClubbed":"_N42LH","Tab":"_1dvN_","TabItem":"_1-V0i","TabItemActive":"_22jQN","TabDetail":"_3N4_N","ErrorBox":"_yThOr","flipOutX":"_36cnV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/Flight/Flight.scss
// module id = 704
// module chunks = 0